import Navbar from "../components/common/Navbar";
import CaseDetail from "../components/casedetail/CaseDetail";

const CasesPage = () => {
  return (
    <>
      <Navbar />
      <CaseDetail />
    </>
  );
};

export default CasesPage;
